__turbopack_context__.v({
  "organizerInfoSection": "RemindMe-module-scss-module__519Ila__organizerInfoSection",
  "remindMeIcon": "RemindMe-module-scss-module__519Ila__remindMeIcon",
  "remindMeModalContent": "RemindMe-module-scss-module__519Ila__remindMeModalContent",
  "reminderSetButtonVariant": "RemindMe-module-scss-module__519Ila__reminderSetButtonVariant",
  "reminderSetDescription": "RemindMe-module-scss-module__519Ila__reminderSetDescription",
  "reminderSetTitle": "RemindMe-module-scss-module__519Ila__reminderSetTitle",
});
